import { Injectable } from "@angular/core";
import { BaseEntityService } from "../services/rest-common.service";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({ providedIn: "root" })
export class PaymentInfoService extends BaseEntityService {

    constructor(
        public http: HttpClient,
        public toastr: NotificationService,
    ) {
        super();
    }

    public resource_url = `${this.BASE_API_URL}/payment-gateway/get-offline-payment-details/`;

    fetchPaymentInfo(params = {}) {
        let url = this.buildUrl(this.resource_url, '', params);
        return this.get(url)
    }
}